const female_last_name = require('./female_last_name');
const male_last_name = require('./male_last_name');
module.exports = female_last_name.concat(male_last_name);


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/cz/name/last_name.js
// module id = 2436
// module chunks = 1610